import React from "react";
import { PRIMARY_COLOR, TERTIARY_COLOR } from "../constants/theme";

const DateItem = ({ date, selectedDate, setSelectedDate }) => {
  const handleSelection = () => {
    if (selectedDate && selectedDate?.fullDate === date?.fullDate) {
      setSelectedDate(undefined);
    } else {
      setSelectedDate(date);
    }
  };
  return (
    <div className="col-auto p-0">
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{
          fontSize: "9px",
          // padding: '10px',
          // fontWeight: '400',
          color: "rgb(203, 108, 230)",
          border: `1px solid ${
            selectedDate?.fullDate === date?.fullDate
              ? PRIMARY_COLOR
              : TERTIARY_COLOR
          }`,
          backgroundColor:
            selectedDate?.fullDate === date?.fullDate
              ? TERTIARY_COLOR
              : "unset",
          borderRadius: "8px",
          lineHeight: "1",
          gap: "4px",
          textAlign: "center",
          width: "58px",
          height: "60px",
          fontWeight: selectedDate?.fullDate === date?.fullDate ? "600" : "400",
        }}
        onClick={() => handleSelection()}
      >
        <div>{date?.day}</div>
        <div
          className=""
          style={{
            fontSize: "22px",
          }}
        >
          {date?.date}
        </div>
        <div className="" style={{}}>
          {date?.month}
        </div>
      </div>
    </div>
  );
};

export default DateItem;
